import React, { useEffect, useState } from 'react'

import { Triggers, useSelector, useTrigger, useDispatch, Actions } from '../../stores/dashboard.store'
import { DashboardNavigationItems } from "../../config/nav"

import { CircularProgress } from '@mui/material'
import NotificationsIcon from '@mui/icons-material/Notifications'

import styles from './styles.module.css'
import BaseMenu from './base-menu'

import { formatDateTime } from '../../util/time'

import { updateQueryParams } from '../../util/util'
import { getTaskById, clearNotifications } from '../../api-client/data'
import { useSnackbar } from '../snackbar/snackbar'

const NotificationItem = ({ notification, navigateToProject }) => {
    const firstItem = notification[0]
    const [data, setData] = useState()

    const fetchTask = async () => {
        try {
            const task = await getTaskById(firstItem?.taskId)
            setData(task)
        } catch { }
    }

    useEffect(() => {
        fetchTask()
    }, [firstItem])

    const localNavigateToProject = () => {
        if (data === undefined) return
        navigateToProject(firstItem?.blueprintId, firstItem?.taskId)
    }

    return (
        <div className={styles.accountMenuItem} style={{ display: 'flex', padding: 15, gap: 10 }} onClick={localNavigateToProject}>
            <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                {
                    ({
                        [true]: <div style={{ height: 55, width: 55, backgroundColor: 'var(--text-secondary)', borderRadius: 4 }}></div>,
                        [data?.status === 'queued' || data?.status === "processing"]: <div style={{ width: 55, height: 55, display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress size="30px" /></div>,
                        [data?.thumbnail?.length > 0]: <img style={{ borderRadius: 4 }} height={55} width={55} src={data?.thumbnail} />,
                    }).true
                }
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: 5 }}>
                <div style={{ textTransform: 'capitalize' }}>{firstItem?.title}</div>
                <div style={{ fontSize: 14, color: `var(--text-secondary)` }}>{formatDateTime(firstItem?.createdAt)}</div>
            </div>
        </div>
    )
}

const NotificationsMenu = ({ buttonRef, open, setOpen, notifications, resetNotifications }) => {
    const { projects } = useSelector()
    const dispatch = useDispatch()
    const selectProject = useTrigger(Triggers?.ProjectList)
    const { enqueueSnackbar } = useSnackbar()

    const navigateToProject = (blueprintId, taskId = undefined) => {
        if (!!taskId) {
            updateQueryParams("tid", taskId)
        }
        const project = projects?.find(x => x?.id === blueprintId)
        if (!project) {
            enqueueSnackbar('Project not found', { variant: 'error' })
            return
        }
        selectProject(project)
        dispatch(Actions.NavigateDashboard, { view: DashboardNavigationItems?.Request, nav: DashboardNavigationItems?._id })
    }

    const onClear = () => {
        clearNotifications()
        resetNotifications()
        setOpen(false)

        enqueueSnackbar('Notifications cleared', { variant: 'info' })
    }

    const items = notifications.reduce((a, c) => {
        if (!Array.isArray(a[c?.taskId])) {
            a[c?.taskId] = []
        }

        a[c?.taskId].push(c)
        return a
    }, {})

    return (
        <BaseMenu buttonRef={buttonRef} open={open} setOpen={setOpen}>
            <div className={styles.accountMenuContainer}>
                {
                    notifications.length > 0 && <div className={styles.clearButton} onClick={onClear}><div>Clear</div></div>
                }
                <div className={styles.accountMenuBody}>
                    {
                        notifications.length === 0 ? (
                            <div style={{ color: 'var(--text-dim)', display: 'flex', padding: 20, alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                                <NotificationsIcon />
                                <div>You have no notifications</div>
                            </div>
                        ) : Object.keys(items)?.map(x => (
                            <NotificationItem notification={items[x]} navigateToProject={navigateToProject} />
                        ))
                    }
                </div>

            </div>
        </BaseMenu>
    )
}

export default (props) => props.open && <NotificationsMenu {...props} />